module.exports = __webpack_public_path__ + "img/t2-c11.29c60827.png";